export default __webpack_public_path__ + "static/media/cbeta.e420362e.png";